export enum Env {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  UAT = 'uat',
  PRODUCTION = 'production',
  DR = 'dr',
}
